import { render, staticRenderFns } from "./EndCardTemplatesList.vue?vue&type=template&id=e0473916&lang=pug&"
import script from "./EndCardTemplatesList.vue?vue&type=script&lang=js&"
export * from "./EndCardTemplatesList.vue?vue&type=script&lang=js&"
import style0 from "./EndCardTemplatesList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports